/**
 * OaSIS Explorer Frontend - Card Component
 * Task 3.1: Frontend Foundation & Global Features
 * 
 * Reusable card component with theme support
 */

import React from 'react';
import type { CardProps } from '../../types';

/**
 * Card component for content containers
 */
export const Card: React.FC<CardProps> = ({
  children,
  className = '',
  title,
}) => {
  const classes = [
    'bg-white',
    'dark:bg-gray-800',
    'border',
    'border-gray-200',
    'dark:border-gray-700',
    'rounded-lg',
    'shadow-sm',
    'hover:shadow-md',
    'transition-shadow',
    'duration-200',
    className,
  ].join(' ');

  return (
    <div className={classes}>
      {title && (
        <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-0">
            {title}
          </h3>
        </div>
      )}
      <div className={title ? 'p-6' : 'p-6'}>
        {children}
      </div>
    </div>
  );
};

